export enum OptionalArticleTypeName {
  teamMembers = 'Team Members',
  birthdays = 'Birthdays',
  newResidents = 'New Residents',
  inLovingMemory = 'In Loving Memory',
}
